import initializeCookieConsentContentWrapper from './Modules/CookieConsentContentWrapper'
import initializeCookieDependencyConfiguration from './Modules/CookieDependencyConfiguration'
import initializeCookieDependencyContent from './Modules/CookieDependencyContent'
import initializeFormCookieSettingsOpener from './Modules/CookieSettingsOpener'

const initNodeTypesOnLoad = function () {
    // for wrapper nodetypes for individual use
    initializeCookieConsentContentWrapper()
    // configuration for code-based plugins etc.
    const cookieDependencyConfiguration = initializeCookieDependencyConfiguration()
    // handles code-based content with cookie dependency
    initializeCookieDependencyContent(cookieDependencyConfiguration)
    // to open cookie settings over individual class
    initializeFormCookieSettingsOpener()
}

if (document.readyState != 'loading') {
    initNodeTypesOnLoad()
} else {
    document.addEventListener('DOMContentLoaded', initNodeTypesOnLoad)
}
